import React from 'react';
import ContainerTemplate from '../../../components/template/Container';
import * as ROUTES from '../../../router/Routes';
import DescuentosView from './DescuentosView';

const DescuentosPage = () => {
  return (
    <ContainerTemplate active={ROUTES.descuentos} routes={[]}>
      <DescuentosView />
    </ContainerTemplate>
  );
};

export default DescuentosPage;
